import HttpClient from "../api/http_client"

const initWXinConfigOld = ( ) => {
    let url = `${location.protocol}//${location.host}${location.pathname}`
    let type = location.pathname.match(/^\/[^\/]*/g)[0].substr(1)
    let shareObj =  type ==='lsvc'? getDefaultShareParams(): getXwxrShareParams()
    if(location.search){
        url += `?${encodeURIComponent(decodeURIComponent(location.search.substr(1)))}`
    }
    url = decodeURIComponent(url).replace(/\=&from.*/,"")
    history.replaceState({},"",url)
    let data = { share_url: url}
    let httpClient = new HttpClient()


    httpClient.post('api/open/wx-share-config', data).then(res => {
        wx.config({
            debug: false,
            appId: res.results.appid,
            timestamp: res.results.timestamp,
            nonceStr: res.results.noncestr,
            signature: res.results.signature,
            jsApiList: ['updateAppMessageShareData',//分享给朋友
                'updateTimelineShareData', //分享到朋友圈
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'hideMenuItems', //批量隐藏功能按钮接口
                'showMenuItems']
        })
        wx.ready(() => {
            wx.checkJsApi({
                jsApiList: ['showMenuItems'],
                success: (res) => {
                    if(res.checkResult.showMenuItems){
                        wx.showMenuItems({
                            menuList: ['menuItem:share:appMessage', //分享给朋友
                                'menuItem:share:timeline', //分享到朋友圈
                                'menuItem:favorite' //收藏
                            ]
                        })
                    }
                }
            })
            wx.updateAppMessageShareData({
                title: shareObj.title,
                desc: shareObj.desc,
                imgUrl: shareObj.imgUrl,
                link: url,
                success: function(){

                }
            })
            wx.updateTimelineShareData({
                title: shareObj.title,
                desc: shareObj.desc,
                imgUrl: shareObj.imgUrl,
                link: url,
                success:function(){

                }
            })
            wx.onMenuShareAppMessage({
                title: shareObj.title,
                desc: shareObj.desc,
                imgUrl: shareObj.imgUrl,
                link: url,
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success:function(){

                }
            })
            wx.onMenuShareTimeline({
                title: shareObj.title,
                desc: shareObj.desc,
                imgUrl: shareObj.imgUrl,
                link: url,
                success:function() {

                }
            })
    }, rej => {
        })
    })
}

const getDefaultShareParams = () => {
    let  shareObj={
        title:  'AME-Medtronic 2017年国际胸腔镜手术视频大赛',
        desc:   '“AME-Medtronic胸腔镜手术视频大赛”由AME与美敦力公司联合举办，旨在推动胸腔镜肺叶/肺段切除技术的发展。',
        imgUrl: 'http://fp.amegroups.cn/cms/0fadd54dbdc9377608df5f53440bf31a.png/w200'
    }
    return shareObj
}

const getXwxrShareParams =() =>{
    let  shareObj={
        title:  '胸外新瑞中国胸外科病例演讲大赛',
        desc:   '胸外新瑞中国胸外科病例演讲大赛由AME出版社和广东省胸部疾病学会主办，阿斯利康公司赞助。',
        imgUrl: 'http://fp.amegroups.cn/cms/b366ad65d40376bdb2db81eaa39abf75.png/w200'
    }
    return shareObj

}

const initWXinConfig = () => {
    try {
        let weiXinShare = new AMEWeiXinShare()
        let url = `${location.protocol}//${location.host}${location.pathname}`
        let type = location.pathname.match(/^\/[^\/]*/g)[0].substr(1)
        let shareObj =  type ==='lsvc'? getDefaultShareParams(): getXwxrShareParams()
        if(location.search){
            url += `?${encodeURIComponent(decodeURIComponent(location.search.substr(1)))}`
        }
        url = decodeURIComponent(url).replace(/\=&from.*/,"")
        history.replaceState({},"",url)
        weiXinShare.wxShareInitial({
            url: url,
            ...shareObj
        })
    } catch (e) {
        console.log(e.toString())
    }
}

export { initWXinConfig }
